export default {
    resetStateMutation() {
    },
}
